exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bottom-nav-container[data-v-35b27d4c] {\n  padding: 20px;\n}\n.upload-tip[data-v-35b27d4c] {\n  color: #f56c6c;\n  font-size: 12px;\n  margin-top: 5px;\n}\n.link-type[data-v-35b27d4c] {\n  color: #409eff;\n  text-decoration: none;\n  cursor: pointer;\n}\n.link-type[data-v-35b27d4c]:hover {\n  text-decoration: underline;\n}\n.upload-label[data-v-35b27d4c] {\n  margin-bottom: 8px;\n}\n.input-limit[data-v-35b27d4c] {\n  position: absolute;\n  right: 10px;\n  top: 0;\n  color: #999;\n  font-size: 12px;\n}", ""]);

// exports
